import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { users, centers } from './../../ducks/selectors';

import Link from './../../components/Link';
import AdminPageShell from '../../components/admin/AdminPageShell';

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: 'all',
      orderBy: 'name',
      order: 'desc',
    };
  }
  orderBy(field) {
    if (field === this.state.orderBy) {
      this.setState({ order: this.state.order === 'desc' ? 'asc' : 'desc' });
    } else {
      this.setState({ orderBy: field, order: 'asc' });
    }
  }
  render() {
    const { classes, users, centers } = this.props;

    let data = users.filter(u => u.name !== null);

    if (this.state.filter !== 'all') {
      data = data.filter(i => i.role === this.state.filter);
    }

    // Специальная обработка для полей, которые требуют преобразования
    const sortData = data.map(user => {
      let sortValue;
      switch (this.state.orderBy) {
        case 'id':
          // Числовая сортировка для Id
          sortValue = user.id || 0;
          break;
        case 'sportComplex':
          // Сортировка по названию первого спортцентра или по количеству
          if (user.sportComplexIds && user.sportComplexIds.length > 0) {
            const center = centers.find(c => c.id === user.sportComplexIds[0]);
            sortValue = center ? center.name : '';
          } else {
            sortValue = '';
          }
          break;
        case 'role':
          // Сортировка по текстовому представлению роли
          if (user.role === 'administrator') sortValue = 'Администратор';
          else if (user.role === 'moderator') sortValue = 'Менеджер';
          else if (user.role === 'mobile') sortValue = 'Пользователь';
          else sortValue = '';
          break;
        default:
          // Для остальных полей (name, phone) используем значение как есть
          sortValue = user[this.state.orderBy] || '';
      }
      return { ...user, _sortValue: sortValue };
    });
    
    data = _.orderBy(sortData, ['_sortValue'], [this.state.order]);
    return (
      <AdminPageShell title="Пользователи">
        <div className={classes.pageBody}>
        <div className={classes.buttonBar}>
          <Select
            value={this.state.filter}
            onChange={event => this.setState({ filter: event.target.value })}
            input={<Input id="filter" />}
          >
            <MenuItem value="all">
              <em>Все</em>
            </MenuItem>
            <MenuItem value="administrator">Администраторы</MenuItem>
            <MenuItem value="moderator">Менеджеры</MenuItem>
            <MenuItem value="mobile">Пользователи</MenuItem>
          </Select>
          <Button to="/new-user" variant="contained" color="primary" component={Link} className={classes.button}>
            Добавить пользователя
          </Button>
        </div>
        <Paper className={classes.paper} elevation={2}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'id'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('id')}
                  >
                    Id
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'name'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('name')}
                  >
                    Имя
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'phone'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('phone')}
                  >
                    Телефон
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'sportComplex'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('sportComplex')}
                  >
                    Спортцентр
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'role'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('role')}
                  >
                    Роль
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data ? (
                data.map(user => (
                  <TableRow
                    className={classes.tableRow}
                    key={user.id}
                    onClick={() => this.props.history.push(`/user/${user.id}`)}
                  >
                    <TableCell>{user.id}</TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.phone}</TableCell>
                    <TableCell>
                      {user.sportComplexIds && user.sportComplexIds.length ?
                      user.sportComplexIds
                        .map((sportComplexId) => {
                          const center = centers.find(c => c.id === sportComplexId);
                          if (center) {
                            return center.name;
                          }
                          return center;
                        })
                        // Фильтруем те спортцентры, которые не найдены
                        .filter(item => !!item).join(', ') : null}
                    </TableCell>
                    <TableCell>
                      {user.role === 'administrator' ? 'Администратор' : null}
                      {user.role === 'moderator' ? 'Менеджер' : null}
                      {user.role === 'mobile' ? 'Пользователь' : null}
                    </TableCell>
                  </TableRow>
                ))
              ) : null}
            </TableBody>
          </Table>
        </Paper>
        </div>
      </AdminPageShell>
    );
  }
}

const styles = theme => ({
  paper: {
    width: '100%',
    overflowX: 'auto',
    flex: 1,
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  pageBody: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flex: 1,
    minHeight: 0,
  },
  buttonBar: {
    height: 67,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  tableRow: {
    cursor: 'pointer',
  },
  table: {
    '& thead th': {
      backgroundColor: '#f8f9fa',
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#495057',
      borderBottom: '2px solid #dee2e6',
    },
    '& tbody tr': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    '& tbody td': {
      borderBottom: '1px solid #e9ecef',
      padding: theme.spacing(1.5),
    },
  },
  button: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
});

const Styled = withStyles(styles)(Users);
export default connect(state => ({ users: users(state), centers: centers(state) }))(Styled);
